var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9995 18.5L7.12451 11.625L9.04951 9.63125L12.6245 13.2062V2H15.3745V13.2062L18.9495 9.63125L20.8745 11.625L13.9995 18.5ZM5.74951 24C4.99326 24 4.34564 23.7305 3.80664 23.1915C3.26764 22.6525 2.9986 22.0053 2.99951 21.25V17.125H5.74951V21.25H22.2495V17.125H24.9995V21.25C24.9995 22.0062 24.73 22.6539 24.191 23.1929C23.652 23.7319 23.0048 24.0009 22.2495 24H5.74951Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadHeader);
export default __webpack_public_path__ + "static/media/download-header.c6e80b478d3ba6f6191bbd41f57bcb2c.svg";
export { ForwardRef as ReactComponent };